<template>
    <div>
        <el-row>
            <el-col :span="24">
                <div>
                    <el-row>
                        <el-col :span="2" class="align-center line-height100 surgeryStatus">
                            <i :style="{ 'background': operatingColor}"></i><span>手术进行中({{ operatingCount }})</span>
                        </el-col>
                        <el-col :span="2" class="align-center line-height100 surgeryStatus">
                            <i :style="{ 'background': operatedColor }"></i><span>手术完成({{ operatedCount }})</span>
                        </el-col>
                        <el-col :span="2" class="align-center line-height100 surgeryStatus">
                            <i :style="{ 'background': operatingCancelColor}"></i><span>手术终止({{ operatingCancelCount }})</span>
                        </el-col>
                        <el-col :span="2" class="align-center line-height100 surgeryStatus"> <i style="background: orange"></i><span>接台时间</span> </el-col>
                        <el-col :span="3" class="align-center line-height100 surgeryStatus">
                            首台准点率:<span style="color: var(--primary-color, #009688)">{{ this.firstSurgeryTime ? this.righttimerate : '--(未设置)' }}</span></el-col
                        >
                        <el-col :span="3" class="align-center line-height100 surgeryStatus">
                            平均接台时间:<span style="color: var(--primary-color, #009688)">{{ calJTtime }}</span></el-col
                        >
                        <el-col :span="4" v-if="isCanSelectRooms=='1'">
                            <item-input type="multiselect" v-model="dic_room_ids" :options="operationRooms" :clearable="true" placeholder="手术间"></item-input>
                        </el-col>
                        <el-col :span="6" class="align-right">
                            <el-button size="mini" plain @click="showTimeLineSetup">
                                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                <span class="hidden-md-and-down">&nbsp;排程时间配置</span>
                            </el-button>
                        </el-col>
                    </el-row>
                    <div class="my-calendar" :style="{ height: `${this.screenHeight2 - 143}px`, background: '#fff' }">
                        <FullCalendar ref="myCalendar" :options="calendarOptions">
                            <template v-slot:eventContent="arg">
                                <div :title="arg.event.extendedProps.surgeries" v-if="arg.event.display != 'background' && arg.event.extendedProps.enum_surgery_status >= -2">
                                    <el-row class="ellipsis" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left">
                                            <b>{{ arg.event.extendedProps.patient_name }}</b>
                                            {{ `${arg.event.extendedProps.sex || '--'}/${arg.event.extendedProps.age || '--岁'}` }}
                                        </el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left"> {{ $moment(arg.event.start).format(`HH:mm`) }}~{{ $moment(arg.event.end).format(`HH:mm`) }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.surgeries }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left">主刀:{{ arg.event.extendedProps.surgeon }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left">麻醉:{{ arg.event.extendedProps.anaes_surgeon }}</el-col>
                                    </el-row>
                                </div>
                                <div v-else-if="arg.event.extendedProps.enum_surgery_status == -100">
                                    <el-row class="ellipsis" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left"></el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left" style="word-wrap: break-word; overflow-wrap: break-word">{{ arg.event.title }}mins</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left"></el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left"></el-col>
                                    </el-row>
                                </div>
                            </template>
                            <template v-slot:resourceLabelContent="arg">
                                <!-- <el-row class="font-size16" style="height: 22px">
                                    <el-col :span="10" class="line-height20" :title="resourceLabelTitle" style="cursor: pointer">
                                        {{ arg.resource.extendedProps.done }}/{{ arg.resource.extendedProps.total }}
                                    </el-col>
                                    <el-col :span="14" class="line-height20 align-right">
                                        <span @click.stop="loadSettingForm(arg.resource.id, arg.resource.title, arg.resource.extendedProps)" class="hasSetting">
                                            <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                        </span>
                                    </el-col>
                                </el-row> -->
                                <div class="operationRoom">
                                    {{ arg.resource.title }}
                                </div>
                            </template>
                        </FullCalendar>
                    </div>
                </div>
            </el-col>
        </el-row>
        <form-dialog
            ref="timeLineSetup-set"
            title="排程时间配置"
            :data="timeLineSetupInfo.data"
            width="30%"
            class="form-table-h360"
            :columns="timeLineSetupInfoColumnList"
            :visible.sync="timeLineSetupInfo.dialogFormVisible"
            @confirm="saveTimeLineSetup"
        ></form-dialog>
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import scrollGridPlugin from '@fullcalendar/scrollgrid'
import zhcnLocale from '@fullcalendar/core/locales/zh-cn' // ⽀持中⽂
import TimeLineSetup from './TimeLineSetup.vue'
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryProcess`,
    components: { FullCalendar, TimeLineSetup },
    props: {},
    data() {
        return {
            calendarOptions: {
                plugins: [interactionPlugin, resourceTimelinePlugin, scrollGridPlugin],
                initialView: `resourceTimelineDay`,
                initialDate: this.$moment().format(`YYYY-MM-DD`),
                locale: zhcnLocale,
                handleWindowResize: true,
                dayMinWidth: 200,
                height: `100%`,
                aspectRatio: 1, // 设置日历单元格宽度与高度的比例。
                headerToolbar: {
                    left: ``,
                    center: `prev title next`,
                    right: ``
                },
                buttonText: {
                    prev: `<`,
                    next: `>`
                },
                views: {
                    resourceTimelineDay: {
                        buttonText: `日`
                    }
                },
                slotMinWidth: `100`, // 横轴模式，每个格子的宽度px,不设置自适应
                slotLabelInterval: `0:30`, // 30分钟下 一小格
                slotDuration: `0:30`, // 时间轴间隔
                slotMinTime: `00:00:00`, // 时间轴开始最小
                slotMaxTime: `24:00:00`, // 时间轴显示的最后一个时隙
                scrollTime: `08:00:00`, // 滚动轴，默认几点开始
                slotLabelFormat: {
                    hour: `2-digit`,
                    minute: `2-digit`,
                    omitZeroMinute: false,
                    meridiem: false,
                    hour12: false
                },
                resourceAreaHeaderContent: ` `,
                resourceAreaWidth: `20%`,
                resources: this.getResources,
                refetchResourcesOnNavigate: true,
                resourceOrder: `display_order`, // 按手术间排序字段 排序
                expandRows: true,
                selectable: true,
                noEventsMessage: `没有手术`,
                nowIndicator: false, // 当前时间 标记线
                allDaySlot: false, // 是否显示全天
                lazyFetching: false,
                eventSources: [
                    // 日历数据来源
                    {
                        id: `1`,
                        events: this.getEvents, // 排程手术列表
                        eventDataTransform: this.eventDataTransform // 把手术数据 转换成 日历能识别的数据格式
                    }
                ],
                schedulerLicenseKey: `0469155259-fcs-1655457743`,
                resourceLaneDidMount: this.resourceLaneDidMount,
                eventOverlap: true,
                slotEventOverlap: true
            },
            title: `手术进程`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            o_dic_operating_ward_id: undefined, // 排程手术区
            operatingCount: 0,
            operatedCount: 0,
            operatingCancelCount: 0,
            others: [],
            scheduled_list: [],
            timeUnit: this.$root.SurgeryTimeUnit && this.$root.SurgeryTimeUnit == `分钟` ? `minutes` : `hours`,
            defaultCostTime: 1, // 默认计时单位 1小时
            operation_ward_all: undefined,
            issetoperatingward: false,
            firstSurgeryTime: null, // 首台开台时间
            offDutyTime: null, // 下班时间
            timeLineSetupInfo: {
                data: {},
                dialogFormVisible: false
            },
            intervaloption: [
                { label: `10分钟`, value: 10 },
                { label: `20分钟`, value: 20 },
                { label: `30分钟`, value: 30 },
                { label: `60分钟`, value: 60 }
            ],
            righttimerate: `--`,
            interval: 0,
            statusStyleConfig: [],
            operatingColor: this.$getThemePrimaryColor(),
            operatedColor: `#78b600`,
            operatingCancelColor: `#f44336`,
            operationRooms: [],
            dic_room_ids: [],
            isRoomSearch: false,
            isCanSelectRooms: this.$root.isCanSelectRooms || 0,
            isNowTime: this.$root.isNowTime || 0,
            SurgeryProcessIntervalRefresh: this.$root.SurgeryProcessIntervalRefresh || `0`,
            intervalRefresh: null
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
    },
    mounted() {
        this.getStatusStyleConfig().then(() => {
            this.LoadTimeLineSetupData()
        })
        if (this.SurgeryProcessIntervalRefresh != `0`) {
            clearInterval(this.intervalRefresh)
            var timeNum = parseInt(this.SurgeryProcessIntervalRefresh)
            this.intervalRefresh = setInterval(() => {
                this.refetch()
            }, timeNum * 1000)
        }
    },
    computed: {
        ...mapGetters([
            `operation_ward`,
            `currentUser`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `sys_enums`,
            `listview/remove_item`,
            `section`,
            `operation_ward_auth`,
            `operation_ward_auth_disabled`,
            `screenHeight`,
            `permissions`,
            `active_ward`
        ]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                if (this.active_ward && _.startsWith(this.active_ward.value, `rw_`)) {
                    this.o_dic_operating_ward_id = 0
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        screenHeight2() {
            return this.screenHeight
        },
        calJTtime() {
            let sum = 0
            if (this.others.length > 0) {
                sum = parseInt(_.sumBy(this.others, function(o) { return o.title }) / this.others.length)
            }

            return sum + `mins`
        },
        timeLineSetupInfoColumnList() {
            return [
                {
                    type: `select`,
                    prop: `interval`,
                    label: `时间轴间隔`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.intervaloption || [],
                    colspan: 14,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `time`,
                    prop: `first_show_time`,
                    label: `时间轴起始时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 14,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: `00:00`,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `time`,
                    prop: `first_surgery_time`,
                    label: `首台开台时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 14,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: `08:00`,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `time`,
                    prop: `off_duty_time`,
                    label: `下班时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 14,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: `18:00`,
                    config: { popperAppendToBody: true }
                }
            ]
        }
    },
    methods: {
        LoadTimeLineSetupData() {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/FullCalendarTimeLineSetup/GetInitData?page=surgery_process`)
                req.then(data => {
                    if (data) {
                        that.timeLineSetupInfo.data = data
                        that.$nextTick(() => {
                            let calendar = that.$refs.myCalendar.getApi()
                            let scrollFirstTime = data && data.first_show_time ? that.$moment(data.first_show_time).format(`HH:mm`) : `08:00:00`
                            if (data && data.first_surgery_time) {
                                that.firstSurgeryTime = that.$moment(data.first_surgery_time).format(`HH:mm`)
                            }
                            if (data && data.off_duty_time) {
                                that.offDutyTime = that.$moment(data.off_duty_time).format(`HH:mm`)
                            }
                            if (data && data.interval) {
                                that.interval = data.interval
                            }

                            let interval = ``
                            switch (that.interval) {
                            case 10:
                                interval = `00:10:00`
                                break
                            case 20:
                                interval = `00:20:00`
                                break
                            case 30:
                                interval = `00:30:00`
                                break
                            case 60:
                                interval = `1:00:00`
                                break
                            default:
                                interval = `1:00:00`
                                break
                            }
                            calendar.setOption(`slotDuration`, interval)
                            if (data && (data.interval == 60 || data.interval == 30 || data.interval == 20)) {
                                calendar.setOption(`slotMinWidth`, 120)
                            } else {
                                calendar.setOption(`slotMinWidth`, 60)
                            }
                            calendar.setOption(`scrollTime`, scrollFirstTime)
                            calendar.setOption(`slotLabelInterval`, interval)
                            calendar.scrollToTime(scrollFirstTime)
                        })
                    }
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getOperationRooms(date) {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetRooms`, { date: date })
                req.then(data => {
                    that.operation_ward_all = _.groupBy(data, `dic_operating_ward_id`)
                    let tmp = that.operation_ward_all && that.operation_ward_all[parseInt(that.dic_operating_ward_id)]
                    tmp = _.orderBy(tmp, `display_order`) || []
                    let currentWardRooms = tmp.map(d => {
                        let c = {
                            id: d.id,
                            title: d.name,
                            done: d.done,
                            total: d.total,
                            anesthetist: (d.room_setting && d.room_setting.anesthetist) || ``,
                            anesthetistObj: (d.room_setting && d.room_setting.anesthetistObj) || null,
                            anesthetist_id: (d.room_setting && d.room_setting.anesthetist_id) || null,
                            anesthetist_assistant: (d.room_setting && d.room_setting.anesthetist_assistant) || ``,
                            anesthetist_assistant_id: (d.room_setting && d.room_setting.anesthetist_assistant_id) || null,
                            anesthetist_assistantsObj: (d.room_setting && d.room_setting.anesthetist_assistantsObj) || null,
                            surgeon_name: (d.room_setting && d.room_setting.surgeon_name) || ``,
                            surgeonObj: (d.room_setting && d.room_setting.surgeonObj) || null,
                            surgeon_id: (d.room_setting && d.room_setting.surgeon_id) || null,
                            dic_surgery_name: (d.room_setting && d.room_setting.dic_surgery_name) || ``,
                            circuit_nurse: (d.room_setting && d.room_setting.circuit_nurse) || ``,
                            circuit_nurse_id: (d.room_setting && d.room_setting.circuit_nurse_id) || null,
                            dic_operating_room: (d.room_setting && d.room_setting.dic_operating_room) || null,
                            dic_operating_room_id: (d.room_setting && d.room_setting.dic_operating_room_id) || null,
                            dic_section_id: (d.room_setting && d.room_setting.dic_section_id) || null,
                            dic_section_name: (d.room_setting && d.room_setting.dic_section_name) || null,
                            dicSectionObj: (d.room_setting && d.room_setting.dicSectionObj) || null,
                            display_order: d.display_order || 0,
                            equipment_nurse: (d.room_setting && d.room_setting.equipment_nurse) || null,
                            equipment_nurse_id: (d.room_setting && d.room_setting.equipment_nurse_id) || null,
                            room_setting_id: (d.room_setting && d.room_setting.id) || 0,
                            label: d.name,
                            value: d.id
                        }
                        return c
                    })
                    that.operationRooms = currentWardRooms // 手术区全部手术间不要过滤
                    if (!that.isRoomSearch) {
                        that.dic_room_ids = (that.operationRooms.length > 0 && that.operationRooms.map(room => room.value)) || []
                    } else {
                        currentWardRooms = _.filter(currentWardRooms, r => {
                            return _.includes(that.dic_room_ids, r.value)
                        })
                    }
                    resolve(currentWardRooms)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getResources(fetchInfo, successCallback, failureCallback) {
            let that = this
            let start = that.$moment(fetchInfo.start).format(`YYYY/MM/DD HH:mm:00`)
            return new Promise(resolve => {
                that.getOperationRooms(start)
                    .then(data => {
                        resolve(data)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        getEvents(fetchInfo, successCallback, failureCallback) {
            let that = this
            let start = this.$moment(fetchInfo.start).format(`YYYY-MM-DD`)
            let end = this.$moment(fetchInfo.end).format(`YYYY-MM-DD`)
            that.$nextTick(() => {
                let calendar = that.$refs.myCalendar.getApi()
                calendar.getEvents().forEach(e => {
                    e.remove()
                })
            })

            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetSurgeryProcess?begin=${start}&end=${end}`)
                // 获取已排程
                let req1 = this.myaxios.get(`/api/Preoperative/Schedule/GetRooms`, { date: start })
                this.myaxios.all(req, req1).then(([data1, data2]) => {
                    let allWards = _.groupBy(data2, `dic_operating_ward_id`)
                    let currentWardRooms = allWards && allWards[parseInt(that.dic_operating_ward_id)]
                    currentWardRooms = _.orderBy(currentWardRooms, `display_order`) || []
                    let currentWardRoomIds = currentWardRooms && currentWardRooms.map(i => i.id)
                    // 按手术区过滤数据
                    if (that.dic_operating_ward_id != undefined) {
                        data1 = _.filter(data1, p => {
                            return (p.enum_surgery_status == -2 || p.enum_surgery_status >= 30) &&
                                p.dic_operating_ward_id == parseInt(that.dic_operating_ward_id) &&
                                that.dic_room_ids.includes(p.dic_operating_room_id)
                        })
                    }

                    this.scheduledCount = this.operatingCount = this.operatedCount = 0
                    // 获取手术中、手术结束的数量
                    this.operatingCount = _.filter(data1, { enum_surgery_status: 30 }).length
                    this.operatedCount = _.filter(data1, p => {
                        return p.enum_surgery_status >= 40
                    }).length
                    // 获取手术终止的数量
                    this.operatingCancelCount = _.filter(data1, { enum_surgery_status: -2 }).length

                    data1 = data1.map(d => {
                        d.start = that
                            .$moment(d.fact_inRoom_time)

                        // 按分钟还是按小时计算结束时间
                        let costTime = 0
                        if (d.fact_outRoom_time) {
                            d.end = that
                                .$moment(d.fact_outRoom_time)
                        } else {
                            if (this.isNowTime == `1` && d.enum_surgery_status == 30) {
                                if (that.$moment().diff(d.start, `minutes`) < 30) {
                                    d.end = that
                                        .$moment(d.fact_inRoom_time)
                                        .add(30, `minutes`)
                                } else {
                                    d.end = that.$moment()
                                }
                            } else {
                                if (d.cost_time && d.cost_time > 0) {
                                    costTime = _.round(d.cost_time, 2)
                                    d.end = that
                                        .$moment(d.fact_inRoom_time)
                                        .add(costTime, that.timeUnit)
                                } else {
                                    d.end = that
                                        .$moment(d.fact_inRoom_time)
                                        .add(1, `hours`)
                                }
                            }
                        }
                        return d
                    })

                    let roomfirstsurgerytimes = []
                    that.others = _.reduce(
                        _.groupBy(data1, `dic_operating_room_id`),
                        function(result, keyitems, gkey) {
                            keyitems = _.orderBy(keyitems, [`fact_inRoom_time`, `scheduled_sequence`], [`asc`, `asc`])
                            if (keyitems.length > 0) {
                            // 获取每个手术间首台手术
                                roomfirstsurgerytimes.push(keyitems[0].fact_inRoom_time)
                            }

                            for (let i = 0; i < keyitems.length; i++) {
                                if (i != keyitems.length - 1) {
                                    let start = keyitems[i].end
                                    let end = keyitems[i + 1].start
                                    if (end > start) {
                                        let nitem = {
                                            id: `jt` + i,
                                            title: that.$moment(end).diff(start, `minutes`),
                                            start: that.$moment(start).format(`YYYY-MM-DD HH:mm:00`),
                                            end: that.$moment(end).format(`YYYY-MM-DD HH:mm:00`),
                                            dic_operating_room_id: gkey,
                                            enum_surgery_status: -100
                                        }
                                        result.push(nitem)
                                    }
                                }
                            }
                            return result
                        },
                        []
                    )

                    if (that.firstSurgeryTime && roomfirstsurgerytimes.length > 0) {
                        let total = roomfirstsurgerytimes.length
                        let righttime = _.filter(roomfirstsurgerytimes, p => {
                            let startTime = that
                                .$moment(p).format(`HH:mm`)
                            return (startTime <= that.firstSurgeryTime)
                        })
                        let tmprighttimerate = (righttime.length / total) * 100
                        that.righttimerate = parseInt(tmprighttimerate) + `%`
                    } else {
                        that.righttimerate = `--`
                    }

                    // 每个手术间 加一个 特殊的事件，用来标记 首台时间
                    let first = {
                        id: -200,
                        title: ``,
                        start: new Date(),
                        end: new Date(),
                        backgroundColor: `red`,
                        resourceIds: currentWardRoomIds,
                        display: `background`
                    }
                    data1.push(first)

                    let offdutytime = {
                        id: -300,
                        title: ``,
                        start: new Date(),
                        end: new Date(),
                        backgroundColor: `red`,
                        resourceIds: currentWardRoomIds,
                        display: `background`
                    }
                    data1.push(offdutytime)
                    let tmp = data1.concat(that.others)
                    that.scheduled_list = tmp
                    resolve(that.scheduled_list)
                })
            })
        },
        getStatusStyleConfig() {
            let that = this
            return new Promise(resolve => {
                // 参数共用
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=SurgeryStatusStyleConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.statusStyleConfig = JSON.parse(data.value)
                        if (this.statusStyleConfig && this.statusStyleConfig.length > 0) {
                            var config1 = _.filter(this.statusStyleConfig, function(i) {
                                return i.value == 30
                            })
                            var config2 = _.filter(this.statusStyleConfig, function(i) {
                                return i.value >= 40
                            })
                            var config3 = _.filter(this.statusStyleConfig, function(i) {
                                return i.value == -2
                            })
                            that.operatingColor = config1 && config1[0] && config1[0].style && config1[0].style.backgroundColor || that.$getThemePrimaryColor()
                            that.operatedColor = config2 && config2[0] && config2[0].style && config2[0].style.backgroundColor || `#78b600`
                            that.operatingCancelColor = config3 && config3[0] && config3[0].style && config3[0].style.backgroundColor || `#f44336`
                        }
                    } else {
                        this.statusStyleConfig = []
                    }
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        eventDataTransform(eventData) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            let dt = this.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            if (eventData.id == -200 && eventData.display == `background`) {
                let start = this.$moment(dt + ` ` + that.firstSurgeryTime + `:00`).format(`YYYY-MM-DD HH:mm:ss`)
                let end = this.$moment(dt + ` ` + that.firstSurgeryTime + `:59`).format(`YYYY-MM-DD HH:mm:ss`)
                eventData.start = start
                eventData.end = end
                eventData.className = `bgclass`
                console.log(`绘制的首台手术时间红线`, eventData)
                return eventData
            }

            if (eventData.id == -300 && eventData.display == `background`) {
                let start = this.$moment(dt + ` ` + that.offDutyTime + `:00`).format(`YYYY-MM-DD HH:mm:ss`)
                let end = this.$moment(dt + ` ` + that.offDutyTime + `:59`).format(`YYYY-MM-DD HH:mm:ss`)
                eventData.start = start
                eventData.end = end
                eventData.className = `bgclass`
                console.log(`绘制的下班时间红线`, eventData)
                return eventData
            }

            let bgcolor = ``
            let color = ``

            if (this.statusStyleConfig && this.statusStyleConfig.length > 0) {
                var config = _.filter(this.statusStyleConfig, function(i) {
                    return i.value == eventData.enum_surgery_status
                })
                if (config.length > 0) {
                    bgcolor = config[0] && config[0].style && config[0].style.backgroundColor || ``
                    color = config[0] && config[0].style && config[0].style.color || `#ffffff`
                } else {
                    switch (eventData.enum_surgery_status) {
                    case -2:
                        bgcolor = `#f44336`
                        color = `#ffffff`
                        break
                    case 30:
                        bgcolor = this.$getThemePrimaryColor()
                        color = `#ffffff`
                        break
                    case 40:
                    case 50:
                    case 60:
                        bgcolor = `#78b600`
                        color = `#ffffff`
                        break
                    case -100:
                        bgcolor = `orange`
                        color = `#ffffff`
                        break
                    default:
                        bgcolor = ``
                        color = `#ffffff`
                    }
                }
            } else {
                switch (eventData.enum_surgery_status) {
                case -2:
                    bgcolor = `#f44336`
                    color = `#ffffff`
                    break
                case 30:
                    bgcolor = this.$getThemePrimaryColor()
                    color = `#ffffff`
                    break
                case 40:
                case 50:
                case 60:
                    bgcolor = `#78b600`
                    color = `#ffffff`
                    break
                case -100:
                    bgcolor = `orange`
                    color = `#ffffff`
                    break
                default:
                    bgcolor = ``
                    color = `#ffffff`
                }
            }
            let data = {
                id: eventData.id,
                title: eventData.title,
                resourceId: eventData.dic_operating_room_id,
                start: that.$moment(eventData.start).format(`YYYY-MM-DD HH:mm:00`),
                end: that.$moment(eventData.end).format(`YYYY-MM-DD HH:mm:00`),
                color: bgcolor,
                textColor: color,
                eventInteractive: true,
                extendedProps: eventData
            }
            return data
        },
        refetch() {
            let that = this
            that.$nextTick(() => {
                let calendar = that.$refs.myCalendar && that.$refs.myCalendar.getApi()
                if (calendar) {
                    calendar.refetchResources()
                    calendar.refetchEvents()
                }
            })
        },
        showTimeLineSetup() {
            let that = this
            that.timeLineSetupInfo.dialogFormVisible = true
        },
        saveTimeLineSetup(row) {
            row.model = 1
            row.available_start_time = this.$moment().format(`YYYY-MM-DD 00:00:00`)
            row.available_end_time = this.$moment().format(`YYYY-MM-DD 23:59:00`)
            row.defaultTimed_event_duration = 60
            row.use_page = `surgery_process`
            this.myaxios.post(`/api/AcisSystem/FullCalendarTimeLineSetup/Put`, row).then(data => {
                this.$message.success(`排程时间设置成功`)
                this.LoadTimeLineSetupData()
                this.timeLineSetupInfo.dialogFormVisible = false
                let calendar = this.$refs.myCalendar.getApi()
                calendar.changeView(`resourceTimelineDay`)
            })
        }
    },
    watch: {
        dic_operating_ward_id: function(newVlaue, oldValue) {
            let that = this
            this.isRoomSearch = false
            that.refetch()
        },
        dic_room_ids: function(newVlaue, oldValue) {
            this.isRoomSearch = true
            this.refetch()
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.bgclass {
    background: red;
    opacity: 1;
}
/deep/.fc-toolbar-chunk {
    display: flex;
}

/deep/ .fc .fc-toolbar.fc-header-toolbar {
    margin-top: 10px;
}
/deep/.fc .fc-button-primary {
    color: var(--primary-color, #009688);
    background-color: #f5f5f5;
    border: 0px;
    border-radius: 50%;
    width: 38px;
    height: 38px;
}
/deep/.fc .fc-button-primary:hover {
    color: var(--primary-color, #009688);
    background-color: #f5f5f5;
    border: 0px;
    border-radius: 50%;
    width: 38px;
    height: 38px;
}

/deep/.cus-form .el-form-item.left .el-form-item__label {
    width: 120px;
}
/deep/.cus-form .el-form-item.left .el-form-item__content {
    margin-left: 120px;
}

.surgeryStatus {
    display: inline-block;
    height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #333333;
    opacity: 1;
    i {
        width: 16px;
        height: 16px;
        display: inline-block;
        border-radius: 50%;
    }
}

.tag {
    width: 130px;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    float: left;
    margin-left: 20px;
    background: #cccccc;
    color: #000;
}
.used {
    background: var(--primary-color, #009688);
    color: #fff;
}

.operationRoom {
    font-size: 16px;
    margin: 0 auto;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/SurgeryProcess.vue